/** Guest tablet vs stylist desk — avoids wiping guest session when staff opens the lobby. */

const MODE_KEY = 'enterprise_salon_kiosk_mode';

export const KIOSK_MODE_GUEST = 'guest';
export const KIOSK_MODE_DESK = 'desk';

export function setSalonKioskMode(mode) {
  try {
    sessionStorage.setItem(MODE_KEY, mode === KIOSK_MODE_DESK ? KIOSK_MODE_DESK : KIOSK_MODE_GUEST);
  } catch {
    /* ignore */
  }
}

export function getSalonKioskMode() {
  try {
    const v = sessionStorage.getItem(MODE_KEY);
    return v === KIOSK_MODE_DESK ? KIOSK_MODE_DESK : KIOSK_MODE_GUEST;
  } catch {
    return KIOSK_MODE_GUEST;
  }
}

export function isSalonDeskMode() {
  return getSalonKioskMode() === KIOSK_MODE_DESK;
}
